export function VercelIcon({ className }: { className?: string }) {
    return (
      <svg 
        className={className} 
        width="64" 
        height="56" 
        viewBox="0 0 64 56" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          d="M32 0L64 56H0L32 0Z" 
          fill="#F2F2F2" 
        />
      </svg>
    )
  }